import { render } from "./RadioFieldWithInstructions.vue?vue&type=template&id=3e967b9c"
import script from "./RadioFieldWithInstructions.vue?vue&type=script&lang=js"
export * from "./RadioFieldWithInstructions.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__